// NATIVE
import { useEffect, useState } from 'react';

// INSTALLED
import { Box, Grid, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { CardUserSystemDetails } from '../../components/generics/CardUserSystemDetails';

// CUSTOM
import { IUserPermissions } from '../../commons/interfaces';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { DetailUserSystemPermissions } from '../../components/generics/DetailUserSystemPermissions';
import { DetailPermissions } from '../../components/generics/DetailPermissions';
import CustomButtonTab from '../../components/CustomButtonTab';
import { Apps } from '@mui/icons-material';
import { getApplicationsPermissionsCustomerStore } from '../../store/customer';
import { getApplicationsPermissionsUserStore } from '../../store/users_permissions';
import { DetalleModuloPemisosUsuario } from '../../components/DetalleModuloPemisosUsuario';

/**
 * DetailUsuarioPermissions component displays the details of a user's permissions.
 *
 * This component fetches user permissions from the Redux store and displays them
 * using the CardUserSystemDetails and DetailUserSystemPermissions components.
 *
 * If no user permissions are found, it navigates back to the user permissions list page.
 *
 * @component
 * @example
 * return (
 *   <DetailUsuarioPermissions />
 * )
 *
 * @returns {JSX.Element} The rendered component.
 */
export const DetailUsuarioPermissions = () => {
  // USE NAVIGATE
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // REDUX
  const { customer }: any = useSelector((state: any) => state.customer);

  const { applicationsList }: any = useSelector((state: any) => state.application);

  // USE SELECTOR
  const { user_with_permissions }: any = useSelector((state: any) => state.usersPermissions);

  const [value, setValue] = useState(0);

  const { state } = useLocation();

  const [idCurrentUser, setIdCurrentUser] = useState(state.userId);

  // USE STATE
  const [userPermissions, setUserPermissions] = useState<IUserPermissions>({
    id: 'Cargando...',
    name: 'Cargando...',
    email: 'Cargando...',
    avatar: 'Cargando...',
    status: 'Cargando...',
    permissions: [],
  });

  useEffect(() => {
    setUserPermissions(user_with_permissions);
  }, [user_with_permissions, customer]);

  // PARA GESTION PERMISOS PANEL TABS ETC

  return (
    <>
      <BreadCrumbsAndTitle
        title="Detalle Usuario Permisos"
        mainModule="configuracion"
        parent="Listar Usuarios Permisos"
        action="/manager/usuarios-permisos"
      />

      <Grid container spacing={2}>
        {/* INICIO LADO A */}
        <Grid size={3}>{CardUserSystemDetails(userPermissions, { showButton: true })}</Grid>
        {/* FIN LADO A  */}

        {/* INICIO LADO B */}
        <Grid size={9}>
          <DetalleModuloPemisosUsuario />
          {/* <DetailPermissions/> */}
        </Grid>
        {/* FIN LADO B  */}
      </Grid>
    </>
  );
};
